import {Observable, Observer,Subject} from 'rxjs/Rx';

export class ProgressService {
  progressEventObservable:Subject<any> = new Subject();
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/customBrowserXhr/progress.service.ts